import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center blueprint-grid" data-testid="auth-loading">
        <Loader2 className="animate-spin text-[var(--cyan)]" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};
